// extracted by mini-css-extract-plugin
export var chip = "_dm-0";
export var filterDropdown = "_dm-5";
export var filterItem = "_dm-6";
export var icon = "_dm-1";
export var removeButton = "_dm-3";
export var removeIcon = "_dm-4";
export var separator = "_dm-2";